import { supabase } from '../supabase';

// Fetch EVERY row of a query, paging past PostgREST's silent 1000-row cap (db-max-rows). A single unpaginated
// response returns the first 1000 with no error, so any "does this exist across the whole table/state" check must
// page or it silently truncates and reads as "not found" — which, for the assessor/collector de-dup match, mints a
// DUPLICATE entity. buildQuery must return a FRESH query builder each call (they're one-shot thenables), WITHOUT a
// .range()/.limit() of its own. Throws on the first page error.
//
// Usage: const rows = await pageAll(() => supabase.from('assessors').select('entity_id,name').eq('state', st));
export async function pageAll(buildQuery) {
  const out = [];
  for (let from = 0; ; from += 1000) {
    const { data, error } = await buildQuery().range(from, from + 999);
    if (error) throw error;
    out.push(...(data || []));
    if (!data || data.length < 1000) break;
  }
  return out;
}
